<div
    [attr.id]="id"
    ngClass="agpr-panel"
    [ngStyle]="style"
    [class]="styleClass"
>
    @if (extraLabel) {
        <div class="agpr-panel-extraLabelWrapper">
            <span class="agpr-panel-extraLabel">
                {{ extraLabel | localize }}
            </span>
        </div>
    }

    @if (showHeader) {
        <div
            [attr.role]="toggleable ? 'button' : null"
            [class]="noBorder ? 'agpr-panel-titlebar agpr-panel-titlebar--noBorder' : 'agpr-panel-titlebar'"
            [class.agpr-panel-titlebar--nonInteractive]="!toggleable"
            [class.agpr-panel-titlebar--collapsed]="collapsed"
            [class.disabled]="disableToggle"
            [id]="id + '_titlebar'"
            [tabindex]="toggleable && !canOnlyClickIcon ? 0 : -1"
            [attr.aria-label]="header ? (header | localize) + ' panel' : null"
            [attr.aria-describedby]="ariaDescribedBy"
            [attr.aria-expanded]="toggleable ? !collapsed : null"
            (keydown)="canOnlyClickIcon || disableToggle ? '' : toggle($event)"
            (click)="canOnlyClickIcon || disableToggle ? '' : toggle($event)"
            [style.margin-top]="marginTop + 'px'"
        >
            @if (headerIcon) {
                <i
                    [class]="'agpr-panel-titleIcon ' + headerIcon"
                    [class.icon-after]="iconAfter"
                    [agprTooltip]="headerIconTooltip ?  (headerIconTooltip | localize) : null"
                ></i>
            }

            @if (header) {
                <span
                    [id]="id + '_label'"
                    class="agpr-panel-title"
                    [ngClass]="headerUppercase ? 'agpr-panel-title-capitalize' : ''"
                    [class.title-with-icon-after]="iconAfter"
                    role="heading"
                    [attr.aria-level]="headingLevel"
                >
                    {{ header | localize }}
                    @if (required) {
                        <span class="agpr-panel-required">*</span>
                    }
                </span>
            }

            @if (tooltip) {
                <span
                    role="img"
                    class="agpr-panel-infoIconStyle fa-regular fa-circle-info"
                    [agprTooltip]="tooltip | localize"
                ></span>
            }

            @if (showCustomHeader) {
                <div class="agpr-panel-customHeader" [id]="id + '_customLabel'">
                        <ng-container *ngTemplateOutlet="panelHeader"></ng-container>
                </div>
            }

            @if (toggleable && !canOnlyClickIcon) {
                <span
                    class="agpr-panel-titlebar-toggler fa-solid agpr-expandToggle"
                    [ngClass]="collapsed ? expandIcon : collapseIcon"
                ></span>
            }

            @if (toggleable && canOnlyClickIcon) {
                <button
                    class="agpr-panel-titlebar-toggler fa-solid agpr-expandToggle"
                    [ngClass]="collapsed ? expandIcon : collapseIcon"
                    [attr.aria-label]="collapsed ? 'Collapsed' : 'Expanded'"
                    [agprTooltip]="toggleArrowTooltip | localize"
                    (click)="toggle($event)"
                    [disabled]="disableToggle"
                ></button>
            }
        </div>
    }

    @if (showSubHeader) {
        <ng-container *ngTemplateOutlet="subHeaderTemplate"></ng-container>
    }

    <div
        #panelContentWrapper
        class="agpr-panel-content-wrapper"
        [@panelContent]="collapsed ? 'hidden' : 'visible'"
        (@panelContent.done)="onToggleDone($event)"
        [ngClass]="{
            'agpr-panel-content-wrapper-overflown': collapsed || animating
        }"
        [attr.role]="isFormGroup ? 'group' : 'region'"
        [attr.aria-hidden]="collapsed"
        [attr.aria-labelledby]="header ? id + '_label' : null"
    >
        <div
            class="agpr-panel-content"
            [class.agpr-panel-content--padded]="contentPadding"
            [style.padding-bottom]="paddingBottom + 'px'"
        >
            <ng-content></ng-content>
        </div>
    </div>
</div>
